export function fmtMoney(v, currency = "USD", compact = false) {
  if (v === null || v === undefined || isNaN(v)) return "-";
  const opts = {
    style: "currency",
    currency,
    maximumFractionDigits: Math.abs(v) >= 10000 ? 0 : 2,
    minimumFractionDigits: 0,
  };
  if (compact && Math.abs(v) >= 100000) opts.notation = "compact";
  return new Intl.NumberFormat("en-US", opts).format(v);
}

export function fmtSignedMoney(v, currency = "USD") {
  if (v === null || v === undefined || isNaN(v)) return "-";
  const s = fmtMoney(Math.abs(v), currency);
  return v >= 0 ? `+${s}` : `-${s}`;
}

export function fmtPct(v, signed = false) {
  if (v === null || v === undefined || isNaN(v)) return "-";
  const s = `${Math.abs(v).toFixed(Math.abs(v) >= 100 ? 0 : 2)}%`;
  if (!signed) return `${v.toFixed(Math.abs(v) >= 100 ? 0 : 2)}%`;
  return v >= 0 ? `+${s}` : `-${s}`;
}

export function fmtNum(v, digits = 0) {
  if (v === null || v === undefined || isNaN(v)) return "-";
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: digits }).format(v);
}

export function pnlClass(v) {
  if (v > 0) return "text-[hsl(var(--profit))]";
  if (v < 0) return "text-[hsl(var(--loss))]";
  return "text-muted-foreground";
}

export function fmtDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("en-US", {
    month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
  });
}

export function fmtMonth(ym) {
  const [y, m] = ym.split("-");
  const d = new Date(Number(y), Number(m) - 1, 1);
  return d.toLocaleDateString("en-US", { month: "short", year: "2-digit" });
}

export function fmtHold(minutes) {
  if (!minutes && minutes !== 0) return "-";
  if (minutes < 60) return `${Math.round(minutes)}m`;
  if (minutes < 1440) return `${(minutes / 60).toFixed(1)}h`;
  return `${(minutes / 1440).toFixed(1)}d`;
}

export function fmtDurationHM(minutes) {
  if (!minutes && minutes !== 0) return "-";
  const total = Math.round(minutes);
  if (total < 60) return `${total}m`;
  if (total < 1440) {
    const h = Math.floor(total / 60);
    const m = total % 60;
    return m ? `${h}h ${m}m` : `${h}h`;
  }
  const d = Math.floor(total / 1440);
  const h = Math.floor((total % 1440) / 60);
  return h ? `${d}d ${h}h` : `${d}d`;
}

export function chartTheme(isDark) {
  return {
    series: isDark
      ? ["#7DD3FC", "#2DD4BF", "#60A5FA", "#94A3B8", "#A8A29E", "#FBBF24"]
      : ["#0A2540", "#0F766E", "#38BDF8", "#64748B", "#A8A29E", "#D97706"],
    profit: "#22C55E",
    loss: "#EF4444",
    grid: isDark ? "#1F2937" : "#E2E8F0",
    axis: isDark ? "#64748B" : "#94A3B8",
    area: isDark ? "#38BDF8" : "#0369A1",
    areaFill: isDark ? "#0EA5E9" : "#0EA5E9",
  };
}

export const RANGE_OPTIONS = [
  { value: "1m", label: "1 Month" },
  { value: "3m", label: "3 Months" },
  { value: "6m", label: "6 Months" },
  { value: "1y", label: "1 Year" },
  { value: "all", label: "All Time" },
];

export function rangeLabel(v) {
  return (RANGE_OPTIONS.find((r) => r.value === v) || {}).label || "All Time";
}
